import React, { useEffect } from "react";
import { Checkbox, FormControlLabel, FormGroup, makeStyles, styled, Switch, TableCell, TableRow } from "@material-ui/core";

import { handleNumber } from "../../../../../../method/displayData";
import { pink } from "@material-ui/core/colors";

let useStyles = makeStyles((theme) => ({
    root: {
        width: "35%",
        minWidth: "33%",
        minHeight: "25vh",
        overflow: "auto",
        backgroundColor: "white",
        padding: 15,
        borderRadius: 5,
        border: "none",
        [theme.breakpoints.down("sm")]: {
            width: "90%",
            maxHeight: "80vh",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        overflow: "auto",
    },
    checkbox: {
        color: "#808080",
        '&.Mui-checked': {
            color: "#E60001",
        },
    },
    checkboxdisable: {
        color: "rgba(0, 0, 0, 0.6)",
        backgroundColor:"rgba(0, 0, 0, 0.6)",
        '&.Mui-checked': {
            color: "rgba(0, 0, 0, 0.6)",
            backgroundColor:"rgba(0, 0, 0, 0.6)"
        },
    }
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#F2F4F6",
        // backgroundColor: "rgba(11,23,66,0.2)",
        cursor: 'pointer',
        color: 'rgb(11,23,66)',
        "&:hover": {
            backgroundColor: "rgba(11,23,66,0.1)",
        }
    },
    "&:nth-of-type(odd)": {
        cursor: 'pointer',
        // backgroundColor: "#F2F4F6",
        // backgroundColor: "rgba(11,23,66,0.2)",
        "&:hover": {
            // backgroundColor:'red',
            backgroundColor: "rgba(11,23,66,0.1)",
        }
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },

}));


export default function Index({ info, index, handleLink, stock, setStock }) {

    let classes = useStyles();
    const [flag, setFlag] = React.useState(false);

    let handelData = (flag) => {
        let data = info;

        if (!flag) {
            removeData()
        }
        if (flag) {
            insertData()
        }
    }

    const insertData = () => {
        if (Object.keys(stock)?.length === 5 && !flag) {
            alert('بیشتر از پنج مورد نمی توانید انتخاب نمایید')
            return
        }
        let data = info;
        setStock(prev => ({
            [data?.id]: data,
            ...prev
        }))
    }

    const removeData = () => {
        let data = info;


        let obj = {}
        Object.keys(stock)
            .forEach((itemKeys) => {
                if (itemKeys !== data?.id) {
                    obj[itemKeys] = stock[itemKeys]
                }
            })

        setStock(obj)
    }

    useEffect(() => {
        if (!stock[info?.id]) {
            setFlag(false)
        }
        if (stock[info?.id]) {
            setFlag(true)
        }
    }, [stock]);



    return (
        <>
            <StyledTableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                style={{ height: 60 }}
                onClick={() => {
                    handelData(!flag);
                }}

            >
                {/* <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {handleLink(info?.body['Attachment'])}
                </TableCell> */}
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {
                        info?.body?.trade_date
                    }
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.commodity_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.offer_symbol}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.manufacturer_detail?.persianName}
                </TableCell>

                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {info?.body?.offer_volume}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.contract_type_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.offer_base_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.maximum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.minimum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"ltr"}
                >
                    {handleNumber(info?.body?.final_weighted_average_price)}

                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.supplier_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.currency_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.measurement_unit_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.settlement_type_name}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.packaging_type_name}
                </TableCell>
                <TableCell
                    align="center"
                >


                    <FormGroup
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}

                    >
                        <FormControlLabel control={
                            <>
                                {

                                    Object.keys(stock)?.length === 5 && (
                                        <>
                                            {
                                                flag && (
                                                    <Checkbox
                                                        className={classes['checkbox']}
                                                        checked={flag}
                                                        onChange={(e) =>

                                                            handelData(e.target.checked)

                                                        }
                                                    />
                                                )
                                            }
                                            {
                                                !flag && (
                                                    <Checkbox
                                                        // style={{ backgroundColor: 'gray' }}
                                                      
                                                        className={classes['checkboxdisable']}
                                                        checked={false}
                                                        disabled={true}
                                                        onChange={(e) => console.log('')

                                                            // handelData(e.target.checked)

                                                        }

                                                    />
                                                )
                                            }
                                        </>
                                    )
                                }
                                {

                                    Object.keys(stock)?.length !== 5 && (
                                        <>

                                            <Checkbox
                                                className={classes['checkbox']}
                                                checked={flag}
                                                onChange={(e) =>

                                                    handelData(e.target.checked)

                                                }
                                                disabled={true}
                                                disableRipple
                                            />

                                        </>
                                    )
                                }
                            </>
                        }
                        />
                    </FormGroup>





                </TableCell>

            </StyledTableRow>
            {/* {
                open && (
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={() => setOpen(false)}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes["root"]}>
                                {
                                    open && (
                                        <Modalsymbol
                                            open={open}
                                            data={info}
                                            setOpen={setOpen}
                                            stock={stock}
                                            setStock={setStock}
                                        />
                                    )
                                }
                            </div>
                        </Fade>
                    </Modal>

                )
            } */}

        </>
    )
}


let test =
{
    'buy_method': 'عادی',
    'commodity_id': 15286,
    'commodity_detail': { 'symbol': 'CEMENT5-50L', 'parentId': 170, 'description': 'سیمان تیپ 5/کیسه50', 'persianName': 'سیمان تیپ 5/کیسه50', 'id': 15286 },
    'contract_type_id': 7,
    'contract_type_detail': { 'description': 'نقدی (مچینگ)', 'persianName': 'نقدی (مچینگ)', 'id': 7 },
    'currency_id': 1,
    'currency_detail': { 'description': 'ریال', 'persianName': 'ریال', 'id': 1 },
    'demand_volume': 100,
    'due_date': '',
    'final_weighted_average_price': 9653,
    'manufacturer_id': 5217,
    'manufacturer_detail': { 'symbol': 'TCC', 'description': 'سیمان تهران', 'persianName': 'سیمان تهران', 'id': 5217 },
    'maximum_price': 9653,
    'measurement_unit_id': 1,
    'measurement_unit_detail': { 'description': 'کیلوگرم', 'persianName': 'کیلوگرم', 'id': 1 },
    'minimum_price': 9653,
    'offer_base_price': 9653,
    'offer_id': 724888,
    'offer_mode': 'عمده',
    'offer_symbol': 'TCC-CEMENT5-50L-00',
    'offer_type': 'عرضه داخلی',
    'offer_volume': 0,
    'seller_broker_id': 45,
    'seller_broker_detail': { 'nationalId': '10860222183', 'spotId': 45, 'derivativesId': 305, 'description': 'مبین سرمایه', 'persianName': 'مبین سرمایه', 'id': 45 },
    'supplier_id': 3364,
    'supplier_detail': { 'customerId': 15124, 'nationalCode': '10861081241', 'description': 'سیمان تهران', 'persianName': 'سیمان تهران', 'id': 3364 },
    'trade_date': '1402/10/02',
    'trade_value': 965300,
    'trade_volume': 100,
    'id_trade': 724888
}